import React from 'react'

const EmptyData = ({ text = "" }) => {
    return (
        <div className="search-bar no-result-message text-center py-4" id='no-data'>
            <h4>{!text ? "No Data found" : text}</h4>
        </div>
    )
}

export default EmptyData